import { DevicesType } from '@pages/booking/types';

export const MAP_DEVICE_TYPE_TO_LABEL: Record<DevicesType, string> = {
    [DevicesType.DUT]: 'DUT',
    [DevicesType.IXIA]: 'IXIA',
    [DevicesType.SPIRENT]: 'Spirent',
};

export const BOOKING_UPDATE_INTERVAL_S = 20;

export const MAP_DEVICE_TYPE_TO_PORTS_PER_SLOT_COUNT: Partial<Record<DevicesType, number>> = {
    [DevicesType.IXIA]: 4,
    [DevicesType.SPIRENT]: 2,
};

export const FUTURE_WEEK_COUNT = 12;
export const PAST_WEEK_COUNT = 4;
export const MIN_DAYS_BOOKING = 0;
export const MAX_DAYS_BOOKING = 90;
export const MIN_HOURS_BOOKING = 1;
